// Source
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelClient from "../../model/custom/Client";
import * as Instance from "../Instance";

export const createData = (
    username: string,
    usernameKana: string,
    usernameOfficial: string,
    usernameAbbreviation: string,
    requestCode: string,
    spcName: string,
    gis: string,
    engagementCode: string,
    country: string,
    isFundRequest: boolean,
    isActive: boolean,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        username,
        username_kana: usernameKana,
        username_official: usernameOfficial,
        username_abbreviation: usernameAbbreviation,
        request_code: requestCode,
        spc_name: spcName,
        gis,
        engagement_code: engagementCode,
        country,
        is_fund_request: isFundRequest,
        is_active: isActive
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/client/create_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const updateData = (
    id: number,
    username: string,
    usernameKana: string,
    usernameOfficial: string,
    usernameAbbreviation: string,
    requestCode: string,
    spcName: string,
    gis: string,
    engagementCode: string,
    country: string,
    isFundRequest: boolean,
    isActive: boolean,
    callback: ModelHelperSrc.IapiCallback
): void => {
    const data = {
        id,
        username,
        username_kana: usernameKana,
        username_official: usernameOfficial,
        username_abbreviation: usernameAbbreviation,
        request_code: requestCode,
        spc_name: spcName,
        gis,
        engagement_code: engagementCode,
        country,
        is_fund_request: isFundRequest,
        is_active: isActive
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/client/update_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const removeData = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/client/remove_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const validationForm = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/client/validation_form", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const dataList = (dataMain: ModelClient.Idata, sortOrder: string, page: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        username: dataMain.username,
        username_kana: dataMain.username_kana,
        latest_update: dataMain.latest_update,
        latest_update_by_id: dataMain.latest_update_by_id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/client/data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const selectOption = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/client/select_option", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
